module.exports = __webpack_public_path__ + "img/rive_de_loire.eba77732.jpeg";